<template>
  <span />
</template>

<script>
import XlsxMixin from "../../../mixins/XlsxMixin.js";
import Catalog from "../RrcvCatalog.js";
import Info from "../RrcvInfo.js";
import Model from "../RrcvModel.js";
import RrcvItemCatalog from "../RrcvItemCatalog.js";

export default {
  mixins: [XlsxMixin],
  props: {
    access: Object,
    userData: Object
  },
  created() {
    this.$emit(this.$kst.Enum.Event.Init, this.exportExcel);
  },
  methods: {
    exportExcel(data, fileName) {
      this.createBook();
      this.createSheet();

      this.addList(data.List);

      this.download(fileName);
    },

    addList(dataList) {
      // label
      this.addColumnHeader_ID();
      this.addColumnHeader_ID(Catalog.ReceiveID.ExportLabel);
      this.addColumnHeader(Catalog.ReceiveID.Label);
      this.addColumnHeader(Catalog.ReturnNumber);
      this.addColumnHeader(Catalog.Date);
      this.addColumnHeader_ID(Catalog.WarehouseID.Label);
      this.addColumnHeader(Catalog.WarehouseID);
      this.addColumnHeader_ID(Catalog.VendorID.Label);
      this.addColumnHeader(Catalog.VendorID);
      this.addColumnHeader(Catalog.VendorAddress);
      this.addColumnHeader(Catalog.Total);

      if (this.userData.WithItems) {
        this.addColumnHeader_ID(RrcvItemCatalog.DispatchID.Label);
        this.addColumnHeader(RrcvItemCatalog.DispatchID);
        this.addColumnHeader(RrcvItemCatalog.Packaging);
        this.addColumnHeader(RrcvItemCatalog.Qty);
        this.addColumnHeader(RrcvItemCatalog.TotalQty);
        this.addColumnHeader(RrcvItemCatalog.BuyPrice);
        this.addColumnHeader(RrcvItemCatalog.SubTotal);
      }

      // value
      for (const row of dataList) {
        this.addRow();

        this.addCellValue_ID(row);
        this.addCellValue("ReceiveID", row, Catalog);
        this.addCellRelatedValue("ReceiveID", row, Catalog);
        this.addCellValue("ReturnNumber", row, Catalog);
        this.addCellValue("Date", row, Catalog);
        this.addCellValue("WarehouseID", row, Catalog);
        this.addCellRelatedValue("WarehouseID", row, Catalog);
        this.addCellValue("VendorID", row, Catalog);
        this.addCellRelatedValue("VendorID", row, Catalog);
        this.addCellValue("VendorAddress", row, Catalog);
        this.addCellValue("Total", row, Catalog);

        if (this.userData.WithItems) {
          Model.updateItemReadOnly(row);

          this.addCellValue("DispatchID", row, RrcvItemCatalog);
          this.addCellRelatedValue("DispatchID", row, RrcvItemCatalog);
          this.addCellValue("Packaging", row, RrcvItemCatalog);
          this.addCellValue("Qty", row, RrcvItemCatalog);
          this.addCellValue("TotalQty", row, RrcvItemCatalog);
          this.addCellValue("BuyPrice", row, RrcvItemCatalog);
          this.addCellValue("SubTotal", row, RrcvItemCatalog);
        }
      }

      this.addSheet(Info.Export.List.Excel.SheetName.List);
    }
  }
}
</script>